import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectModBusDashboardFilters,
  setModBusDashboardFilters,
} from "../../../../redux/features/mob-bus/mob-bus-slice";
import { EDateTypes } from "../../../../shared/oversight-core/enums/date-types";
import FilteringSidePanel from "../../../../shared/oversight-core/shared-components/filtering-side-panel/filtering-side-panel";
import AppDateRangeSelector from "../../../../shared/oversight-core/ui-elements/app-date-range-selector/app-date-range-selector";

interface IProps {
  showFilter: boolean;
  setShowFilter: (value: boolean) => void;
}

const FilterMonitorSidePanel = (props: IProps) => {
  const { showFilter, setShowFilter } = props;

  const dispatch = useDispatch();

  const modBusFilterFilterStore = useSelector(selectModBusDashboardFilters);

  const [selectedDateType, setSelectedDateType] = useState(
    modBusFilterFilterStore.selectedDateType,
  );
  const [selectedDate, setSelectedDate] = useState(
    modBusFilterFilterStore.selectedDate,
  );

  return (
    <FilteringSidePanel
      isOpen={showFilter}
      onClose={() => {
        setShowFilter(false);
      }}
      onFilter={() => {
        dispatch(
          setModBusDashboardFilters({
            selectedDate,
            selectedDateType,
          }),
        );
        setShowFilter(false);
      }}
      onClearAll={() => {
        dispatch(
          setModBusDashboardFilters({
            selectedDate: new Date(),
            selectedDateType: EDateTypes.DAILY,
          }),
        );
        setSelectedDateType(EDateTypes.DAILY);
        setSelectedDate(new Date());
        setShowFilter(false);
      }}
    >
      <>
        <div className="mt-4">
          <AppDateRangeSelector
            startDate={selectedDate}
            endDate={new Date()}
            setSelectedDate={(startDate: Date) => {
              setSelectedDate(startDate);
            }}
            dateTypes={[
              [EDateTypes.DAILY, EDateTypes.WEEKLY, EDateTypes.MONTHLY],
            ]}
            selectedDateType={selectedDateType}
            setSelectedDateType={setSelectedDateType}
            showDatePicker={false}
            isShowDatePicker={true}
          />
        </div>
      </>
    </FilteringSidePanel>
  );
};

export default FilterMonitorSidePanel;
